import React from "react";

export default function NotAllowed({
  isUserAllowed,
  isLoading,
  loadingMessage = "Comprobando rol...",
  notAllowedMessage = "No dispone de un rol válido para visualizar esta página.",
}) {
  let content =
    typeof notAllowedMessage === "string" ? (
      <h1>{notAllowedMessage}</h1>
    ) : (
      notAllowedMessage
    );

  if (!isUserAllowed && isLoading) {
    content = <h1>{loadingMessage}</h1>;
  }

  return <div className="NotAllowed">{content}</div>;
}
